import { Check, CheckCircle, Close } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import { Box } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid';

import TableActionButtons from '../../components/shared/TableActionButtons/TableActionButtons';

const buttons = ({
  type,
  groupAction,
  mappingAction,
  editAction,
  canDetail,
  canEdit,
  canEditMapping,
}) => {
  const result = [];

  if (type === '0' && canDetail) {
    result.push({
      label: 'گروه کد‌ها',
      Icon: InfoIcon,
      onClick: groupAction,
      color: 'primary',
    });
  }

  if (type === '2' && canEditMapping) {
    result.push({
      label: 'مپ پروفایل',
      Icon: InfoIcon,
      onClick: mappingAction,
      color: 'primary',
    });
  }

  if (canEdit) {
    result.push({
      label: 'ویرایش',
      Icon: ModeEditOutlineIcon,
      onClick: editAction,
      color: 'info',
    });
  }

  return result;
};

const useCodingProfileTableColumns = (
  goToGroupPage,
  openMapping,
  deleteItem,
  editItem,
  onSetDefault,
  tableRef,
  columnPermissions = {},
) => {
  const {
    canDetail = false,
    canEdit = false,
    canDelete = false,
    canEditMapping = false,
    canSetDefault = false,
  } = columnPermissions;

  const canViewActions = canDetail || canEdit || canDelete;

  const columnsData = [
    {
      field: 'title',
      headerName: 'عنوان',
      flex: 1,
      minWidth: 180,
      resizable: true,
      editable: false,
      renderCell: params => {
        tableRef.current = params.api;
        return params.row.title;
      },
    },

    {
      field: 'typeValue',
      headerName: 'نوع',
      flex: 1,
      minWidth: 120,
      resizable: true,
      editable: false,
    },

    {
      field: 'logicDisplay',
      headerName: 'منطق',
      flex: 1,
      minWidth: 120,
      resizable: true,
      editable: false,
    },

    {
      field: 'isDefault',
      headerName: 'کد پیش‌فرض',
      flex: 1,
      minWidth: 120,
      resizable: true,
      editable: false,
      renderCell: params => {
        tableRef.current = params.api;
        return params.row.isDefault ? (
          <Box display="flex" alignItems="center" gap={1}>
            <Check />
          </Box>
        ) : (
          <Box display="flex" alignItems="center" gap={1}>
            <Close color="disabled" sx={{ opacity: 0.6 }} />
          </Box>
        );
      },
    },

    ...(canViewActions
      ? [
          {
            field: 'actions',
            headerName: 'عملیات',
            type: 'actions',
            flex: 0.5,
            align: 'right',
            minWidth: 360,

            getActions: params => {
              const { row } = params;
              const actionButtons = buttons({
                type: row.type,
                groupAction: () => goToGroupPage(row.id),
                mappingAction: () => openMapping(row.id),
                editAction: editItem(row),
                canDetail,
                canEdit,
                canEditMapping,
              });

              return [
                actionButtons.length ? (
                  <TableActionButtons key={10} buttons={actionButtons} />
                ) : null,
                canDelete ? (
                  <GridActionsCellItem
                    key={1}
                    icon={<DeleteIcon />}
                    label="حذف"
                    onClick={deleteItem(params.row)}
                    showInMenu
                  />
                ) : null,
                canSetDefault && !row.isDefault && row.titleRequired ? (
                  <GridActionsCellItem
                    key={2}
                    icon={<CheckCircle />}
                    label="تبدیل به کد پیش‌فرض"
                    onClick={onSetDefault(params.row)}
                    showInMenu
                  />
                ) : null,
              ].filter(Boolean);
            },
          },
        ]
      : []),
  ];

  return [columnsData];
};

export default useCodingProfileTableColumns;
